import { render } from "./Caja.vue?vue&type=template&id=aeae8a28&scoped=true"
import script from "./Caja.vue?vue&type=script&lang=js"
export * from "./Caja.vue?vue&type=script&lang=js"

import "./Caja.vue?vue&type=style&index=0&id=aeae8a28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aeae8a28"

export default script